import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  Text,
  IconButton,
  Spacer,
  HStack,
} from '@chakra-ui/react';
import { CloseCircleOutline } from '@aslanpay/portal-common-lib';
import { useManagingCompanyStore } from 'app/store';

import CreatePotForm from './CreatePotForm/CreatePotForm';
import { CreatePotModalProps } from './CreatePotModal.types';

function CreatePotModal({ isOpen, onClose, group, onSuccess = () => {} }: CreatePotModalProps) {
  const company = useManagingCompanyStore((state) => state.company);

  const companyId = company?.id || '';

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="4xl" isCentered>
      <ModalOverlay />
      <ModalContent maxW="592px" w="592px">
        <ModalHeader pb={4}>
          <HStack align="flex-start">
            <Text as="h4" fontStyle="h4Bold" color="brand.black">
              Create new pot
            </Text>

            <Spacer />
            <IconButton
              variant="link"
              icon={<CloseCircleOutline boxSize="30px" />}
              aria-label="Close create new pot modal"
              onClick={onClose}
            />
          </HStack>
        </ModalHeader>
        <ModalBody pb={6}>
          <CreatePotForm
            onClose={onClose}
            onSuccess={onSuccess}
            companyId={companyId}
            predefinedGroup={group}
          />
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}

export default CreatePotModal;
